<h1 class="sr-only"><span>PREGUNTAS FRECUENTES SOMOS SORTEO ANÁHUAC MAGNO 2026</span></h1>


<section id="faqs" class="banner-padding">
    <div class="container">
        <div class="row sub-headers-inside">


            <div class="col-12 text-center my-auto">
                <div class="overlap-signature header-inside">

                    <span class="letter"> <span class="signature-text">Preguntas</span></span>
                    <h2 class="main-text">frecuentes</h2>
                </div>
            </div>



        </div>
    </div>
</section>

<section class="faqs" data-aos="fade-up" data-aos-easing="ease" data-aos-duration="3000">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div id="accordion">

                    <div class="card" *ngFor="let faq of faqsList; let i = index">
                        <div class="card-header w-100" [id]="'faqHeader' + i">
                            <a class="btn-link collapsed" data-toggle="collapse" [attr.data-target]="'#collapse' + i" 
                               [attr.aria-expanded]="i === 0 ? 'true' : 'false'" 
                               [attr.aria-controls]="'collapse' + i">
                                <span class="f-bold">
                                    {{ faq.question }}
                                </span>
                            </a>
                        </div>

                        <div [id]="'collapse' + i" class="collapse" [class.show]="i === 0" [attr.aria-labelledby]="'faqHeader' + i" data-parent="#accordion">
                            <div class="card-body">
                                <div [innerHTML]="faq.safeAnswerHtml"></div>
                            </div>
                        </div>
                    </div>
                    </div>
            </div>
        </div>
    </div>
</section>